import React from 'react'

export default function CardQuote ({ fill, ...others }) {
  return (
    <svg
      width="26"
      height="21"
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...others}
      aria-hidden="true"
    >
      <path
        d="M1.15111 20.4798C0.831109 20.4798 0.575109 20.3838 0.383109 20.1918C0.255109 19.9358 0.255109 19.6478 0.383109 19.3278L7.19911 1.56781C7.39111 1.05581 7.74311 0.799805 8.25511 0.799805H11.7111C12.0311 0.799805 12.2551 0.895805 12.3831 1.08781C12.5751 1.27981 12.6391 1.53581 12.5751 1.85581L7.19911 19.7118C7.00711 20.2238 6.62311 20.4798 6.04711 20.4798H1.15111ZM13.9191 20.4798C13.5991 20.4798 13.3431 20.3838 13.1511 20.1918C13.0231 19.9358 13.0231 19.6478 13.1511 19.3278L19.9671 1.56781C20.1591 1.05581 20.5111 0.799805 21.0231 0.799805H24.4791C24.7991 0.799805 25.0231 0.895805 25.1511 1.08781C25.3431 1.27981 25.4071 1.53581 25.3431 1.85581L19.9671 19.7118C19.7751 20.2238 19.3911 20.4798 18.8151 20.4798H13.9191Z"
        fill={fill}
      />
    </svg>
  )
}
